<template>
  <dialog-modal-fi
    ref="dialog"
    class="media-library-zoom-image-dialog-fi modal-fi--large"
    only-body-scrollable
    :no-max-height="isModalFullscreen"
    @after-open-transition="showImage"
    @close="isImageEnabled = false"
  >
    <template #header>
      <div class="media-library-zoom-image-dialog-fi__headline">
        {{ itemTitle }}
      </div>
    </template>
    <template #body>
      <div class="media-library-zoom-image-dialog-fi__media-container">
        <loading-indicator
          v-if="true"
          class="media-library-zoom-image-dialog-fi__loading-indicator"
          variant="spinnerLocal"
        />
        <cloud-image-fi
          v-if="isImageEnabled && mediaUrl"
          :key="mediaUrl"
          class="media-library-zoom-image-dialog-fi__media"
          :src="mediaUrl"
          :alt="itemTitle"
          :params="cloudImageParams"
          full-height
        />
      </div>
    </template>
    <template #footer>
      <div class="media-library-zoom-image-dialog-fi__details">
        <div class="media-library-zoom-image-dialog-fi__file-info">
          <div
            v-if="itemSource && mediaUrl"
            class="media-library-zoom-image-dialog-fi__file-source"
          >
            {{ $dict.get('media-Library.Items.Source-Label-Images') }}
            {{ itemSource }}
          </div>

          <div
            v-if="fileUrl"
            class="media-library-zoom-image-dialog-fi__file-size"
          >
            <span class="media-library-zoom-image-dialog-fi__file-size-value">
              {{ getFileSizeAndLabel(fileSizeInBytes) }}</span
            >
            <span>{{ fileExtension }}</span>
          </div>
        </div>

        <a
          v-if="mediaUrl"
          :href="mediaUrl"
          class="button-fi__icon button-fi__primary"
          download
          @click="handleDownload"
        >
          <icon-fi icon="download" />
        </a>
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script>
import { CloudImageFi, DialogModalFi, IconFi, LoadingIndicator } from 'atoms';
import mediaLibraryMixin from 'mixins/mediaLibraryMixin';
import { mapGetters } from 'vuex';

import eventHubMixin from '@/mixins/eventHubMixin.vue';

export default {
  name: 'MediaLibraryZoomImageDialogFi',
  components: {
    DialogModalFi,
    IconFi,
    CloudImageFi,
    LoadingIndicator,
  },
  mixins: [mediaLibraryMixin, eventHubMixin],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isNewsroom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentWindowWidth: 0,
      dprDesktop: 1.2,
      isImageEnabled: false,
      isMounted: false,
    };
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    ...mapGetters({
      windowDimensions: 'layout/getWindowDimensions',
    }),
    isModalFullscreen() {
      return this.isMounted ? this.currentWindowWidth < 600 : false;
    },
    mediaUrl() {
      return this.isNewsroom ? this.image : this.fileUrl;
    },
    dprParam() {
      return !IS_SSR && window?.devicePixelRatio < this.dprDesktop ? `&dpr=${this.dprDesktop}` : '';
    },
    cloudImageParams() {
      return `func=${this.isNewsroom ? 'fit' : 'boundmin'}&aspect_ratio=16:9&force_format=png${
        this.dprParam
      }`;
    },
  },
  watch: {
    windowDimensions: {
      deep: true,
      immediate: true,
      handler() {
        this.updateWindowWidth();
      },
    },
  },
  methods: {
    show() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    updateWindowWidth() {
      if (IS_SSR) {
        return;
      }

      this.currentWindowWidth = window.innerWidth;
    },
    async showImage() {
      this.isImageEnabled = true;

      if (IS_SSR) {
        return;
      }

      await this.$nextTick();
      window.dispatchEvent(new Event('resize'));
    },
    handleDownload() {
      this.sendEvent('custom', {}, 'download', {
        link: this.downloadUrl,
        name: this.itemTitle,
      });
    },
  },
};
</script>

<style lang="scss">
@import './media-library-zoom-image-dialog-fi-unscoped';
</style>
